// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__2Eq4f","content":"styles_content__2oCyZ","selectAll":"styles_selectAll__3qAoM"};